import { render, staticRenderFns } from "./NoService.vue?vue&type=template&id=615b4e91&scoped=true&"
import script from "./NoService.vue?vue&type=script&lang=js&"
export * from "./NoService.vue?vue&type=script&lang=js&"
import style0 from "./NoService.vue?vue&type=style&index=0&id=615b4e91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b4e91",
  null
  
)

export default component.exports